/**
 * 全局参数表单（ParamForm / 副玩法页的 TField）的字段 → 接口视角登记 id（src/api-lens/entries/common.ts）。
 * 页面上的字段名是人读的（regen = 分钟），登记按服务端列名（diceRegenSec = 秒）：两者的对应就是 server-config.ts 的 toDice 等换算。
 * 参数类型是 Record<string, …>，漏写编译拦不住；漏了的登记会让 src/api-lens/api-lens.test.ts 红。
 */


export const DICE_LENS: Record<string, string> = {
  E: "common.eTargetMilliB",
  rho: "common.costRatioBps",
  incomeK: "common.incomeGrowthBps",
  incomeAnchor: "common.incomeAnchorB",
  targetBase: "common.targetRollsBase",
  targetGrowth: "common.targetRollsGrowthBps",
  cap: "common.diceCapBase",
  capStep: "common.diceCapPerLevel",
  capStarStep: "common.diceCapPerStar",
  regen: "common.diceRegenSec",
  pDouble: "common.pDoubleBps",
  capMax: "common.diceCapMax",
  init: "common.diceInit",
  subgamePick: "common.subgameClientPick",
  warpProb: "common.warpProbBps",
  reliefQty: "common.reliefDiceQty",
  reliefTimes: "common.reliefDailyTimes",
  reliefThreshold: "common.reliefDiceThreshold",
  idlePct: "common.idleTapPctBps",
  idleMax: "common.idleTapMaxBps",
  idleCap: "common.idleTapCapPerRoll",
};

export const FIGHT_LENS: Record<string, string> = {
  stealPct: "common.stealPctBps",
  stealCap: "common.stealCapB",
  stealFloor: "common.stealFloorB",
  atkSuccess: "common.atkSuccessBps",
  atkBlock: "common.atkBlockB",
  protectNpc: "common.protectNpcLevel",
  protectHalf: "common.protectHalfLevel",
  giftCap: "common.dailyGiftCap",
  stakeTierBase: "common.stakeTierBase",
  askCap: "common.dailyAskCap",
  wardCap: "common.shieldMax",
  clawbackDays: "common.luckyKeepDays",
  clawbackBonus: "common.luckyBonusBps",
  repairPct: "common.repairPctBps",
  visitCap: "common.dailyStolenCap",
  matchRange: "common.matchRangeLevels",
  thunderPct: "common.thunderPctBps",
  thunderCap: "common.thunderCapB",
  thunderFloor: "common.thunderFloorB",
  friendLimit: "common.friendLimit",
  socialEventCap: "common.dailySocialEventCap",
  avatarUploadCap: "common.dailyAvatarUploadCap",
  uidQueryCap: "common.dailyUidQueryCap",
  puzzleHintCap: "common.puzzleHintDailyLimit",
  cardLimit: "common.dailyCardLimit",
  puzzleLimit: "common.dailyPuzzleLimit",
  adLimit: "common.dailyAdLimit",
};

export const PET_STAR_LENS: Record<string, string> = {
  starMax: "common.petStarMax",
  maxedCoin: "common.petMaxedCoin",
  maxedApplyMultiplier: "common.petMaxedApplyMultiplier",
  maxedCountsAsAdopt: "common.petMaxedCountsAsAdopt",
};

export const INTIMACY_LENS: Record<string, string> = {
  idolDailyCap: "common.intimacyIdolDailyCap",
};

export const LAMP_LENS: Record<string, string> = {
  pityThreshold: "common.lampPityThreshold",
};

export const PETTOWN_LENS: Record<string, string> = {
  maxStar: "common.pettownMaxStar",
  starsPerLevel: "common.pettownStarsPerLevel",
  repairPct: "common.pettownRepairPctBps",
  attackerPct: "common.pettownAttackerPctBps",
  protectStar: "common.pettownProtectStar",
  matchRangeStars: "common.pettownMatchRangeStars",
};
